import { render, staticRenderFns } from "./breakRecord.vue?vue&type=template&id=83d96148&scoped=true"
import script from "./breakRecord.vue?vue&type=script&lang=js"
export * from "./breakRecord.vue?vue&type=script&lang=js"
import style0 from "./breakRecord.vue?vue&type=style&index=0&id=83d96148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d96148",
  null
  
)

export default component.exports